export default __webpack_public_path__ + "d7ab36838dab43417a4c4c4f6cefba75.png";